module.exports = __webpack_public_path__ + "static/commercial-gates-42c87b9ee7ffaea27b35b8df292d4d5e.jpg";